import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from '@material-ui/core';
import { actions } from '../../../../store/nav';

export function onClickHandler(url, primaryText, showActions, navItem, onNavItem) {
  window.location.assign(url);
  showActions();
  navItem({
    url,
    primaryText,
  });
  onNavItem({
    url,
    primaryText,
  });
}

export function NavActionImpl({
  primaryText, url, showActions, navItem, onNavItem,
}) {
  return (
    <Button
      style={{
        width: '170px',
        height: '40px',
        backgroundColor: 'white',
        fontSize: '14px',
        margin: '10px auto',
        display: 'flex',
        textOverflow: 'ellipsis',
      }}
      onClick={() => onClickHandler(url, primaryText, showActions, navItem, onNavItem)}
    >
      {primaryText}
    </Button>
  );
}

NavActionImpl.propTypes = {
  primaryText: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  showActions: PropTypes.func.isRequired,
  navItem: PropTypes.func.isRequired,
  onNavItem: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  showActions: actions.showActions,
  navItem: actions.navItem,
};

export default connect(
  null,
  mapDispatchToProps,
)(NavActionImpl);
